module.exports = __webpack_public_path__ + "img/thermometer.54b12c68.svg";